<template>
  <div class="no-authority">
    <a-empty :description="'无访问权限'" >
      <!-- :image="''" -->
    </a-empty>
  </div>
</template>

<script>
export default {
    name:'NoAuthority',

};
</script>

<style scoped lang="less">

.no-authority{
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
}


/deep/.ant-empty-image{
    height: 200px !important;
}

/deep/.ant-empty-description{
    font-size: 18px;

}
</style>